import { DateRangePickerInput } from '@sequencehq/core-components'
import { useSelectedDateRange } from 'RevenueRecognition/view/utils/useSelectedDateRange'

export const RevRecDashboardDateFilter = () => {
  const { dateRange, setDateRange } = useSelectedDateRange()

  return <DateRangePickerInput value={dateRange} onChange={setDateRange} />
}
